import { create } from 'zustand';
import { axiosClient } from '../services/api';

interface ServiceMeta {
  maxParticipants?: number;
}

interface ServiceMetaState {
  credits: { [serviceId: string]: number };
  meta: { [serviceId: string]: ServiceMeta };
  fetchServiceCredits: () => Promise<void>;
  getMeta: (serviceId: string) => ServiceMeta | undefined;
  setMeta: (serviceId: string, metadata: ServiceMeta) => void;
}

export const useServiceMetaStore = create<ServiceMetaState>((set, get) => ({
  credits: {},
  meta: {},
  fetchServiceCredits: async () => {
    try {
      const response = await axiosClient.get('/api/services-meta/credits');
      set({ credits: response.data });
    } catch (error) {
      console.error('Failed to fetch service credits:', error);
    }
  },
  getMeta: (serviceId: string) => {
    return get().meta[serviceId];
  },
  setMeta: (serviceId: string, metadata: ServiceMeta) => {
    set((state) => ({
      meta: {
        ...state.meta,
        [serviceId]: metadata
      }
    }));
  },
}));
